// extracted by mini-css-extract-plugin
export default {"row":"createCompetition_row__BMD39","col":"createCompetition_col__4kzmN","card":"createCompetition_card__xsnvP"};